<template>
	<b-container fluid class="p-0">
		<div>
			<h6 class="py-3 rounded text-dark  text-center u:bg-white-3 shadow-sm">{{"En servicio de reserva "}}</h6>
			<div class="row no-gutters justify-content-center">
				<div class="col-4 px-3" v-for="(itemPrice, indexPrice) in tempAddtService.rates" :key="indexPrice">
					<h6 class="p-1 text-primary  text-center text-capitalize">{{itemPrice.category +" - "+'$'+itemPrice.price}}</h6>
					<div class="input-group mb-3 ">
						<div class="input-group-prepend">
							<button class="btn btn-outline-primary"  type="button" @click="decremetItem(indexPrice)">-</button>
						</div>
						<label class="form-control text-center">{{itemPrice.quantity}}</label>
						<div class="input-group-append ">
							<button class="btn btn-outline-primary" type="button" @click="incremetItem(indexPrice)">+</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-container class="mb-0 pb-0" v-if="editPrice">
				<b-row class="edit-amount py-2">
				<div class="col-12">
					<b-form-group
						id="input-group-1"
						label-for="input-1"
					>
						<label class="mr-sm-2">Nuevo Total</label>
							<b-input-group size="lg" prepend="$" :append="currency">
								<b-form-input v-model="specialRateData.amount" type="number"></b-form-input>
							</b-input-group>
					</b-form-group>
				</div>
				<div class="col-12">
					<b-form-group id="input-group-2" label="Motivo" label-for="input-2">
						<b-form-textarea v-model="specialRateData.reason"></b-form-textarea>
					</b-form-group>
				</div>
				</b-row>
			</b-container>

		<div class="w-100 d-flex justify-content-center align-items-center p-3 shadow-lg bg-white rounded">

			<span v-if="$hasPermission('reservation.specialRate') && propAddtService.settingVars.editPrice">
				<b-button @click="edit(true)" class="mr-1" variant="outline-success" size="sm" v-if="!editPrice && _cartTotal > 0">
				<md-icon  icon="mode_edit " />
			</b-button>
			<b-button @click="edit(false)" class="mr-1" variant="outline-danger" size="sm" v-if="editPrice">
				<md-icon  icon="clear " />
			</b-button>
			</span>
			<h4 class="flex-grow-1 p-1 m-0 text-success text-uppercase">{{currency}}$ {{ editPrice ? specialRateData.amount : _cartTotal}}</h4>
			<button @click="sendConfirmation()" class="align-self-end btn btn-success">Confirmar</button>
		</div>
		<b-overlay :show="showConfirmation" no-wrap>
			<template #overlay>
				<div ref="dialog" tabindex="-1" role="dialog" class="text-center p-1">
                <strong>¿Esta seguro que desea aplicar el precio especial?</strong><br>

                 <p>Precio original: {{originalPriceFormatted}} </p>
                 <p>Precio especial: {{newPriceFormatted}} </p>
                 <h4 class="text-success"><b>{{difference}}</b></h4>
					<div class="text-center">
						<b-button variant="outline-danger" class="mr-3" @click="()=>{showConfirmation=false}">
							Cancelar
						</b-button>
						<b-button variant="outline-success" @click="sendConfirmation()">Confirmar</b-button>
					</div>
				</div>
			</template>
		</b-overlay>
	</b-container>
</template>

<script>
export default {
	props:{
		propViewModel:Object,//lista de rides
		propAddtService:Object,//item del servicio adicional seleccionado
		currency:{type: String, required: true,default: "usd"}
	},
	data() {
		return {
			listTransportServices: null,
			editPrice: false,
			showConfirmation: false,
			specialRateData: {
				amount: 0,
				reason: ''
			},
			tempAddtService: {
				id: -1,
				related: {},
				name:"",
				additionalServiceTypeId: -1,
				bookingPriceSubtotal: 0,//?
				bookingCurrency: "usd",
				total: 0,//?total del servicio
				quote: {
					bookingPriceTotal: 0,
					bookingPriceTotalOriginal: 0,
					specialRate: false,
					bookingCurrency: null,
					specialRateData: null
				},
				currency: "usd",
				rates:[],//{category: "unit",quantity: 0,price: 0}
				status: "pending",
				fromQuote: true//? bandera para indicar que se agrego desde desde el cotizador
			},
		}
	},
	computed:{
		_cartTotal() {
			let total=0;
			//validamos que exista una lista de transport services
			if(this.tempAddtService==null){
				return total;
			}
			this.tempAddtService.rates.forEach(itemPrice => {
				total=total+(itemPrice.price*itemPrice.quantity)
			});
			return total;
		},
		originalPriceFormatted(){
            return "$"+this._cartTotal+" "+ this.propAddtService.priceCurrency;
        },
        newPriceFormatted(){
            return "$"+this.specialRateData.amount+" "+ this.propAddtService.priceCurrency;
        },
		difference(){
            let res = parseFloat(this.specialRateData.amount-this._cartTotal).toFixed(2)
            if(res>=0){
                return "Total AGREGADO: $"+res+" "+this.propAddtService.priceCurrency
            }else{
                return "Total DESCUENTO: $"+Math.abs(res)+" "+this.propAddtService.priceCurrency
            }
        }
	},
	mounted(){
		setTimeout(()=>{
			//buscamos si existe un servicio adicional relacionado con el transport service
			let modelServiceAdditional={};
			let existAddtService = this.propViewModel.additionalServices.find(itemAddtService=>{
				// es nuevo additional service?
				if(itemAddtService.id==-1){
					if(this.propAddtService.id == itemAddtService.additionalServiceTypeId){
						modelServiceAdditional=itemAddtService;
						return true;
					}
				}
				return false;
			});
			if(existAddtService){
				this.tempAddtService = modelServiceAdditional;
				if(modelServiceAdditional.quote.specialRate) {
					this.editPrice = true
					this.specialRateData = {...modelServiceAdditional.quote.specialRateData}
				}
			} else {
				//armamos el modelo nuevo para el servicio adiconal
				this.tempAddtService=  {
					id: -1,
					related: {},
					name:this.propAddtService.name,
					additionalServiceTypeId: this.propAddtService.id,
					bookingPriceSubtotal: 0,//?
					bookingCurrency: this.propAddtService.priceCurrency,
					total: 0,//?total del servicio
					quote: {
						bookingPriceTotal: 0,
						bookingPriceTotalOriginal: 0,
						specialRate: false,
						bookingCurrency: this.propAddtService.priceCurrency,
						specialRateData: null
					},
					currency: this.propAddtService.priceCurrency,
					rates:this.propAddtService.prices,//{category: "unit",quantity: 0,price: 0}
					status: "pending",
					fromQuote: true//? bandera para indicar que se agrego desde desde el cotizador
				};
			}
			console.log("Modal reservation quantity: ");
			console.log(this.tempAddtService);
			console.log(this.propViewModel);
		}, 200);
	},
	methods:{
		edit(isEdit) {
			if(isEdit) {
				this.editPrice = true
				this.specialRateData.amount = this._cartTotal
			} else {
				this.editPrice = false
				this.specialRateData.amount = 0
			}
		},
		calculaTotalAddtService(){
			//validamos que exista una lista de transport services
			if(this.tempAddtService==null){
				return;
			}
			let total=0;
			//iteramos en los rates para obtener el total del paquete
			this.tempAddtService.rates.forEach(itemPrice => {
				total += itemPrice.price*itemPrice.quantity
			});
			this.tempAddtService.quote.bookingPriceTotal=total;
		},
		sendConfirmation(){
			//validamos los campos de cantidad por AdtService
			if (this._cartTotal<=0) {
				this.$root.showAlert("Debe seleccionar al menos un precio", { variant: "danger" });
				return;
			}
			if (this.editPrice) {
				if (this.specialRateData.amount <=0 || !this.specialRateData.amount) {
					return this.$root.showAlert("Debe agregar un precio valido", { variant: "danger" });
				}
				if (!this.specialRateData.reason) {
					return this.$root.showAlert("El motivo es requerido", { variant: "danger" });
				}

				if(! this.showConfirmation) {
					return this.showConfirmation = true
				} else {
					this.showConfirmation = false
				}
			}


			//recuperamos los tempAdditionalServices y los vinculamos a additionalServices del modelo principal
			let auxViewModel = JSON.parse(JSON.stringify(this.propViewModel));

			//buscamos si existe un servicio adicional relacionado con el transport service
			let indexAddtionalService=-1;
			let existAddtService = auxViewModel.additionalServices.find((itemAddtService, indexAS)=>{
					// coinciden los id de referencias?
				if(itemAddtService.id==-1){
					if(this.propAddtService.id == itemAddtService.additionalServiceTypeId){
						indexAddtionalService = indexAS;
						return true;
					}
				}
					return false;
			});
			const tempAdditionalService = JSON.parse(JSON.stringify(this.tempAddtService))
			if(this.editPrice) {
				tempAdditionalService.quote = {
					bookingPriceTotal: Number(this.specialRateData.amount),
					bookingPriceTotalOriginal: this._cartTotal,
					specialRate: true,
					bookingCurrency: this.propAddtService.priceCurrency,
					specialRateData: JSON.parse(JSON.stringify(this.specialRateData))
				}
			} else {
				tempAdditionalService.quote.specialRate = false
			}
			if(existAddtService){
				auxViewModel.additionalServices[indexAddtionalService]=tempAdditionalService;
				console.log("estado editado");
				console.log(auxViewModel);
			}else{
				console.log("ADDSer: agregado");
				auxViewModel.additionalServices.push(tempAdditionalService);
			}
			this.$emit('confirmQuantity', auxViewModel, "Reservation")
		},
		incremetItem(indexSelectedPrice){
			let auxTempAddtService = JSON.parse(JSON.stringify(this.tempAddtService));
			auxTempAddtService.rates.forEach((itemPrice, indexRate) => {
				if(indexRate==indexSelectedPrice){
					if(itemPrice.quantity>=100){
						itemPrice.quantity=100;
					} else {
						itemPrice.quantity++;
					}
				}
			});
			this.tempAddtService=auxTempAddtService;
			this.calculaTotalAddtService();
		},
		decremetItem(indexSelectedPrice){
			let auxTempAddtService = JSON.parse(JSON.stringify(this.tempAddtService));
			auxTempAddtService.rates.forEach((itemPrice, indexRate) => {
				if(indexRate==indexSelectedPrice){
					if(itemPrice.quantity<=0){
						itemPrice.quantity=0;
					} else {
						itemPrice.quantity--;
					}
				}
			});
			this.tempAddtService=auxTempAddtService;
			this.calculaTotalAddtService();
		}
	}
}
</script>

<style lang="scss" scoped>
.edit-amount {
	background-color: #f2f2f2;
}
</style>
